<tidy-card>
  @if (paymentMethod?.status) {
    <tidy-row>
      @if (paymentMethod?.status !== 'succeeded') {
        <ion-chip [class]="paymentMethod?.class">
          @if (paymentMethod?.icon) {
            <ion-icon [name]="paymentMethod?.icon" />
          }
          <ion-label>{{ ((paymentMethod?.status.replace('_', ' ')) | translate) | titlecase }}</ion-label>
        </ion-chip>
      }
    </tidy-row>
  }
  <tidy-row [class.extra-bottom-padding]="!paymentMethod?.metadata?.bank_name" class="vertical-align-center">
    <tidy-image
      [src]="paymentMethod?.type === 'card' ? 'assets/svg/card.svg' : 'assets/img/bank.png'"
      class="header-size" />
    <tidy-text
      [header]="(paymentMethod?.type === 'card' ? ('Card' | translate) : ('Bank Account' | translate)) + (paymentMethod?.metadata?.last4 ? (' ending in ' | translate) + (paymentMethod?.metadata?.last4 | translate) : '')" />
    @if (paymentMethod?.is_primary) {
      <tidy-text [header]="'(primary)'" style="margin-left: 5px" />
    }
  </tidy-row>
  @if (paymentMethod?.metadata?.bank_name) {
    <tidy-row>
      <tidy-text
        [body]="bankDisplayName" />
    </tidy-row>
  }

  @if (paymentMethod?.action_required === 'collect_bank_info') {
    <tidy-card-button
      (action)="addMissingBankInfo(paymentMethod)"
      >
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/arrow-redo-outline.svg'"
          class="body-size" />
        <tidy-text [body]="'Add Missing Bank Info'" />
      </tidy-row>
    </tidy-card-button>
  }

  @if (paymentMethod?.action_required === 'collect_microdeposit_info') {
    <tidy-card-button
      (action)="validateBankAccount(paymentMethod)"
      >
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/arrow-redo-outline.svg'"
          class="body-size" />
        <tidy-text [body]="'Validate Bank Account'" />
      </tidy-row>
    </tidy-card-button>
  }

  @if (paymentMethod?.action_required === 'requires_confirmation') {
    <tidy-card-button
      (action)="confirmPaymentMethod(paymentMethod)"
      >
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/arrow-redo-outline.svg'"
          class="body-size" />
        <tidy-text [body]="'Confirm Payment Method'" />
      </tidy-row>
    </tidy-card-button>
  }

  @if (paymentMethod?.status === 'succeeded') {
    <tidy-card-button (action)="goToLoadCredit(paymentMethod)">
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/cash-outline.svg'"
          class="body-size" />
        <tidy-text [body]="'Load Credit'" />
      </tidy-row>
    </tidy-card-button>
  }

  @if (paymentMethod?.metadata?.last4 && !paymentMethod?.is_primary && paymentMethod?.type === 'card') {
    <tidy-card-button
      (action)="makeCardPrimary(paymentMethod)"
      >
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/svg/checkmark-circle-outline.svg'"
          class="body-size" />
        <tidy-text [body]="'Make Primary'" />
      </tidy-row>
    </tidy-card-button>
  }

  <tidy-card-button (action)="confirmDeletePaymentMethod(paymentMethod)">
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/svg/close-circle-outline.svg'"
        class="body-size" />
      <tidy-text [body]="teamId ? 'Remove from Group' : 'Delete'" />
    </tidy-row>
  </tidy-card-button>
</tidy-card>
